// extracted by mini-css-extract-plugin
export var errorIcon = "_ov-1";
export var nameLogo = "_ov-0";